var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIvms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0178 35.9985C31.8558 35.9985 35.7778 32.0765 35.7778 27.2385C35.7778 22.4005 31.8558 18.4785 27.0178 18.4785C22.1798 18.4785 18.2578 22.4005 18.2578 27.2385C18.2578 32.0765 22.1798 35.9985 27.0178 35.9985Z",
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0156 48.7383C38.8897 48.7383 48.5156 39.1124 48.5156 27.2383C48.5156 15.3642 38.8897 5.73828 27.0156 5.73828C15.1415 5.73828 5.51562 15.3642 5.51562 27.2383C5.51562 39.1124 15.1415 48.7383 27.0156 48.7383Z",
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51562 27.2383H11.7456M42.2856 27.2383H48.5156",
    stroke: "#8F4300",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIvms);
export default __webpack_public_path__ + "static/media/Feature_IVMS.55fabca9a33aced6830be65e0cd00eb4.svg";
export { ForwardRef as ReactComponent };